import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <div className="h-screen flex flex-col items-center justify-center bg-gradient-to-r from-blue-100 to-blue-300 p-4">
            <div className="text-center bg-white p-8 rounded-lg shadow-lg">
                {/* Conteneur de l'image avec centrage */}
                <div className="flex justify-center mt-10">
                    <img
                        src="/img/404-error.png"
                        alt="404 Not Found"
                        className="w-80 h-auto"
                    />
                </div>
                <h2 className="text-2xl font-semibold text-gray-700 mb-6">Page Non Trouvée</h2>
                <p className="text-gray-500 mb-8">Désolé, la page que vous cherchez n'existe pas ou a été déplacée.</p>
                <Link
                    to="/"
                    className="bg-axa-blue-400 text-white px-6 py-3 rounded-md text-lg font-semibold hover:bg-hover-axa-blue transition duration-300"
                >
                    Retour à l'Accueil
                </Link>
            </div>
        </div>
    );
};

export default NotFound;
